export const ExcelImportOptions = {
  System: 'Systems',
  ThermalMethod: 'Thermal Methods',
  SystemThermalMethodMapping: 'System Thermal Method Mapping',
  FacadeInsertUnit: 'Facade Insert Unit',
  FacadeSpacer: 'Facade Spacer',
  FrenchUfValuesWindow: 'French UF Values Windows',
  GermanUfEquationFacade: 'German UF Equation Facades',
  GermanUfEquationWindow: 'German UF Equation Windows',
  GermanUfValuesSlidingDoor: 'German UF Values Sliding Doors',
  GermanUfValuesWindow: 'German UF Values Windows'
}